import {
  isOnboardingFormRoute,
  isOnboardingSetupRoute,
  isPostOnboardingSetupRoute,
  isPromptSetupRoute,
  userNeedsOnboarding,
  userNeedsPromptSetup,
} from './userProfile';

/** Log out control while profile / prompt setup is in progress (no full nav chrome). */
export function shouldShowOnboardingLogout(pathname: string, hasAccessToken: boolean): boolean {
  return hasAccessToken && isOnboardingSetupRoute(pathname);
}

/** Routes where onboarding / setup chrome should stay minimal. */
export function isOnboardingRoute(pathname: string): boolean {
  return (
    isOnboardingFormRoute(pathname) ||
    isPromptSetupRoute(pathname) ||
    pathname === '/get-started' ||
    pathname === '/create-portfolio'
  );
}

/** Header nav after profile onboarding (hidden again until prompts are done). */
export function shouldShowPostOnboardingNav(
  pathname: string,
  user?: Record<string, unknown> | null,
  promptCount?: number
): boolean {
  if (userNeedsOnboarding(user)) {
    return false;
  }
  if (isPostOnboardingSetupRoute(pathname)) {
    return false;
  }
  if (typeof promptCount === 'number' && userNeedsPromptSetup(promptCount, user)) {
    return false;
  }
  return true;
}
